import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as locationInformationStyles from "../../styles/landing_pages/LocationInformation.module.css"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

export default function LocationInformation(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `location-information-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const answer = content.childNodes
    .filter(node => node.classNames.includes("answer"))
    .map(t => t.text)

  const question = content.childNodes
    .filter(node => node.classNames.includes("question"))
    .map(q => q.text)

  return (
    <div
      className={`row ${props.className} ${locationInformationStyles.wrapper}`}
    >
      <div
        className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 ${locationInformationStyles.content}`}
      >
        <h1
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {question.map((q, idx) => (
          <span key={idx}>
            <h4>{q}</h4>
            <p>{answer[idx]}</p>
          </span>
        ))}
      </div>
      <div
        className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 ${locationInformationStyles.image}`}
      >
        <WPImage
          holder={content}
          selector={`media-asset`}
          mode={DISPLAY_MODE.normal}
        />
      </div>
    </div>
  )
}
